// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const OktaState = t.struct({
    isAuthenticated: t.maybe(t.Boolean),
    userId: t.String,
    userName: t.String,
}, 'OktaState');

export const getDefaultState = () => new OktaState({
    isAuthenticated: null,
    userId: '',
    userName: '',
});

export default OktaState;
